import React from "react";
import { Flex } from "@fluentui/react-northstar";
import PropTypes from "prop-types";
import ImageTitleContainer from "../ImageTitleContainer";
import SecureLoginImage from "../../../assets/images/undraw_secure_login_pdn4.svg";
import Constants from "../../../constants/text-constants";
import ChangePasswordForm from "../../molecules/Forms/ChangePasswordForm";
import { observer } from "mobx-react-lite";

const ChangePasswordSettings = observer((props) => {
  const { onClose } = props;


  return (
    <Flex
      className={"change-password-settings-container"}
      data-testid="changePasswordSettings"
    >
      <ImageTitleContainer
        image={SecureLoginImage}
        title={Constants.CHANGE_PASSWORD}
        subTitle={Constants.USE_PASSWORD_TO_SIGN_IN_FROM_NOW_ON}
        testId="changePasswordSettingsContainer"
      >
        <ChangePasswordForm
          changePasswordComplete={onClose}
          displayCancel 
          onCancel={onClose} 
          testId="changePasswordForm"/>
      </ImageTitleContainer>
    </Flex>
  );
});

ChangePasswordForm.propTypes = {
  onClose: PropTypes.func,
};

export default ChangePasswordSettings;